import { capitalize, startCase, defaultTo } from 'lodash';
import { PromotionDuration } from '@atlassian/cssxp-types-promotion';
import { Promotion, SubBenefitType, Benefit } from '@css-xp/graphtypes';

export const getSubBenefitType = (type: SubBenefitType | undefined) => {
  return type === 'PERCENTAGE' ? '%' : type === 'TRIAL' ? 'TRIAL' : '';
};

export const pluraliseBillingCycle = (iterations: string | number) => {
  return 'billing cycle' + (+iterations > 1 ? 's' : '');
};

export const getPromotionDuration = (benefit: Benefit) => {
  return benefit?.duration === PromotionDuration.REPEATING && benefit?.iterations
    ? `${benefit.iterations} ${pluraliseBillingCycle(benefit.iterations)}`
    : capitalize(benefit?.duration ?? '');
};

export const getPromotionType = (promotion: Promotion) => {
  let promotionType = promotion && promotion.type && promotion.type.replace(/_/g, ' ');
  if (promotionType === 'PROMO CODE') {
    promotionType = 'VENDOR PROMOTION';
  }
  return `Type: ${defaultTo(startCase(promotionType?.toLowerCase()), 'N/A')}`;
};

export const getBenefitsLength = (promotion: Promotion) => {
  const promotionBenefits = (promotion && promotion?.benefits) || [];
  const benefitLength = promotionBenefits?.length;
  if (benefitLength === 0) return null;
  return `${benefitLength} benefit` + (+benefitLength > 1 ? 's' : '');
};

export const renderPromotionBenefits = (promotion: Promotion) => {
  const promotionBenefits = (promotion && promotion.benefits) || [];
  const benefitLength = promotionBenefits.length;
  if (benefitLength === 0) return null;

  const allPromotionBenifits = promotionBenefits.map((benefit) => {
    if (!benefit) {
      return null;
    }
    const duration = benefit && getPromotionDuration(benefit);
    const durationContent = `Duration: ${duration}`;
    const benifitContent = `Benefit: ${benefit.value}${getSubBenefitType(benefit.subBenefitType as SubBenefitType)}`;
    const benifitType = benefit?.benefitType?.toLowerCase();

    return `${benifitContent} ${benifitType}, ${durationContent}`;
  });

  return allPromotionBenifits.filter((benifit) => benifit).join(' ');
};
